import React, { useMemo, useRef } from 'react';
import { pick } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { useJackpotUpdateFrame } from '@interlayer/js/app/components/common/Jackpot/hooks/useJackpotUpdateFrame';
import { formatDate, formatTime } from '@interlayer/js/app/utils/dateFormatter.util';

import style from '../../StickyFooter.scss';

const getTimeValue = (sessionStartTime = 0, sessionStartBrowserTime = sessionStartTime) =>
    new Date().getTime() - (sessionStartBrowserTime - sessionStartTime) - sessionStartTime;

const getTimeString = (isLoggedIn: boolean, timeValue: number) => isLoggedIn
    ? formatTime(new Date(timeValue), true)
    : formatTime();

export const Timer: React.FC = () => {
    const {
        isLoggedIn, sessionStartTime, sessionStartBrowserTime
    } = useUserSelector(pick(['isLoggedIn', 'sessionStartTime', 'sessionStartBrowserTime']));
    const dateRef = useRef<HTMLSpanElement>(null);
    const timeRef = useRef<HTMLSpanElement>(null);
    const date = useMemo(formatDate, []);
    const updateFn = () => {
        const timeValue = getTimeValue(sessionStartTime, sessionStartBrowserTime);

        if (dateRef.current) {
            dateRef.current.textContent = date;
        }

        if (timeRef.current) {
            timeRef.current.textContent = getTimeString(isLoggedIn, timeValue);
        }
    };

    useJackpotUpdateFrame(`${sessionStartTime || 'guest'}`, updateFn);

    return (
        <span>
            <span className={style.date} ref={dateRef} />

            <span className={style.timer} ref={timeRef} />
        </span>
    );
};
